/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileBz2 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M11.741 11.983c.64 0 1.108.109 1.407.325.304.216.456.552.456 1.007 0 .336-.126.617-.38.842a1.41 1.41 0 0 1-.291.195c.193.06.355.144.485.253.267.217.4.525.4.925 0 .492-.168.861-.504 1.105-.335.243-.847.365-1.532.365h-1.8v-5.017zm-.724 4.189h.683c.354 0 .614-.055.78-.165.165-.11.247-.283.247-.518 0-.23-.082-.398-.248-.504-.165-.105-.425-.159-.779-.159h-.683zm0-2.111h.524c.363 0 .618-.046.766-.138.151-.097.228-.258.228-.483a.64.64 0 0 0-.097-.373.526.526 0 0 0-.31-.2 2.191 2.191 0 0 0-.587-.062h-.524zm7.006-1.332-2.375 3.36h2.464V17H14.29v-.766l2.36-3.34h-2.277v-.91h3.65zm2.276-.766c.358 0 .662.056.91.166.253.11.444.27.573.482.134.207.2.46.2.76 0 .183-.036.368-.11.552a2.886 2.886 0 0 1-.366.62c-.166.226-.391.497-.676.814l-.695.767h1.861V17h-3.264v-.725l1.256-1.38c.244-.266.432-.482.566-.648.138-.17.235-.313.29-.428a.8.8 0 0 0 .083-.33c0-.203-.07-.358-.207-.464-.134-.11-.33-.165-.587-.165-.129 0-.26.014-.394.041-.133.028-.27.07-.413.124a4.419 4.419 0 0 0-.463.214v-.924c.216-.11.45-.196.697-.255.253-.065.5-.097.739-.097z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileBz2 as FileBz2 };
